import { useRef } from 'react';

import { config } from 'config';
import { AsYouType } from 'libphonenumber-js';
import { useTranslation } from 'libs/i18n';
import { Link, Typography } from 'libs/ui';

import { ContentStyled } from './SubTitle.styles';

export const SubTitle = () => {
  const { t } = useTranslation();

  const subtitles = t('onboarding-success-status.subtitle', {
    returnObjects: true,
  });

  const emailOrder = config.EMAIL_ORDER;
  const emailMiddleOffice = config.EMAIL_MIDDLE_OFFICE;

  const whatsapp = (config.WHATSAPP_PHONE ?? '').replace('+', '');

  const asYouType = useRef(new AsYouType()).current;
  asYouType.reset();

  const whatsappFormat = asYouType.input(`+${whatsapp}`);

  return (
    <ContentStyled spacing={16} spacingMobile={12}>
      {subtitles.map((texts) => (
        <Typography as="p" className="onboardingSuccessStatus-subtitle">
          {texts.map((v) => {
            if (v.type === 'email-order')
              return (
                <Link
                  className="onboardingSuccessStatus-subtitle"
                  href={`mailto: ${emailOrder}`}
                  mode="text"
                >
                  {emailOrder}
                </Link>
              );

            if (v.type === 'email-middle-office')
              return (
                <Link
                  className="onboardingSuccessStatus-subtitle"
                  href={`mailto: ${emailMiddleOffice}`}
                  mode="text"
                >
                  {emailMiddleOffice}
                </Link>
              );

            if (v.type === 'whatsapp')
              return (
                <Link
                  className="onboardingSuccessStatus-subtitle"
                  href={`https://api.whatsapp.com/send?phone=${whatsapp}`}
                  mode="text"
                  target="_blank"
                >
                  {whatsappFormat}
                </Link>
              );

            if (v.type === 'bold') {
              return (
                <Typography
                  as="span"
                  className="onboardingSuccessStatus-subtitle"
                  variant="bodyBold"
                  variantMobile="captionBold"
                >
                  {v.value}
                </Typography>
              );
            }

            return v.value;
          })}
        </Typography>
      ))}
    </ContentStyled>
  );
};
